module.exports = __webpack_public_path__ + "img/Banner-Identification.bfd9bc32.png";